import styled from 'styled-components';

export const Container = styled.section`
    @media screen and (min-width: 0px) {
        width: 100%;
        padding: 1em;

        button {
            background: none;
            border: none;
            margin-top: 10px;
            margin-bottom: 5px;
            padding: 0;

            img {
                width: 10px;
                height: 10px;
            }
        }

        h1 {
            span {
                font-size: 1.125em;
                font-weight: 500;
            }
            font-size: 16px;
            p {
                margin: 0;
                font-weight: bold;
                span {
                    font-weight: bold;
                }
            }
        }
    }

    @media screen and ( min-width: 992px ) {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 2em;
        /* margin-bottom: 1.5em; */

        button {
            display: none;
        }

        h1 {
            text-align: center;
        }
    }    
`